import { ApiError } from '@eneco/dc/client/ApiError';
import { sendHardwareLeads } from '@eneco/dc/services/sales/EnecoInHouseService';
import { SendLeadResponse, DynamicLeadPayload } from '@monorepo-types/dc/sales';
import { assign, fromPromise, setup } from 'xstate';

import { HeatPumpLeadFlowContext } from '../types/context';

interface LeadsMachineContext extends HeatPumpLeadFlowContext {
  errorMessage?: string;
}
type LeadsMachineEvent = {
  type: 'SEND_ORDER';
  values: { requestBody: DynamicLeadPayload };
};
interface InputType {
  event: LeadsMachineEvent;
}

interface OutputType {
  data: SendLeadResponse;
}

export const leadsMachine = setup({
  types: {} as {
    context: LeadsMachineContext;
    events: LeadsMachineEvent;
    actors: {
      sendOrder: {
        input: InputType;
        output: OutputType;
      };
    };
  },
  actors: {
    sendOrder: fromPromise<OutputType, InputType>(({ input }) => {
      return new Promise((resolve, reject) => {
        sendHardwareLeads(input.event.values)
          .then(response => {
            resolve({ data: response });
          })
          .catch((error: ApiError) => {
            reject(new Error(error?.message));
          });
      });
    }),
  },
}).createMachine({
  id: 'leads',
  initial: 'IDLE',
  context: {},
  states: {
    IDLE: {
      on: { SEND_ORDER: 'LOADING' },
    },
    LOADING: {
      invoke: {
        src: 'sendOrder',
        input: ({ event }) => ({ event }),
        onDone: {
          target: 'SUCCESS',
          actions: ({ event, context }) => {
            return { ...context, ...event.output.data };
          },
        },
        onError: {
          actions: assign({
            errorMessage: ({ event }) => (event.error as Error).message,
          }),
          target: 'ERROR',
        },
      },
    },
    SUCCESS: { type: 'final' },
    ERROR: {},
  },
});
